import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Field } from "./Common";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Switch } from "./ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const FEATURES = [["home_visits", "Home visits"], ["shop", "Shop"], ["packages", "Packages & gift cards"], ["marketing", "Marketing campaigns"],
  ["ai", "AI Scribe & assistant"], ["whatsapp", "WhatsApp messages"], ["chat", "Online chat"], ["content", "Reviews & blog"],
  ["recruitment", "Team recruitment page"], ["invoices", "Invoices"]];

export function ClinicFeaturesDialog({ clinic, onClose, onDone }) {
  const [f, setF] = useState({});
  const [lim, setLim] = useState({ locations: "", staff: "" });
  useEffect(() => {
    if (!clinic) return;
    setF(Object.fromEntries(FEATURES.map(([k]) => [k, clinic.features?.[k] !== false])));
    setLim({ locations: clinic.limits?.locations ?? "", staff: clinic.limits?.staff ?? "" });
  }, [clinic]);
  const save = async () => {
    try {
      await api.patch(`/platform/clinics/${clinic.id}`, { features: f, limits: lim });
      toast.success("Features saved"); onClose(); onDone();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={!!clinic} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-y-auto" data-testid="clinic-features-dialog">
        <DialogHeader><DialogTitle>Features · {clinic?.name}</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground">Calendar, patients, payments and consents are always included. Switched-off features disappear from the clinic's menu and public pages.</p>
        <div className="divide-y">
          {FEATURES.map(([k, label]) => (
            <label key={k} className="flex items-center justify-between py-2.5 text-sm">{label}
              <Switch data-testid={`feature-${k}`} checked={!!f[k]} onCheckedChange={(v) => setF({ ...f, [k]: v })} />
            </label>
          ))}
        </div>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Max locations (empty = no limit)"><Input type="number" min={1} data-testid="limit-locations" value={lim.locations} onChange={(e) => setLim({ ...lim, locations: e.target.value })} /></Field>
          <Field label="Max active staff (empty = no limit)"><Input type="number" min={1} data-testid="limit-staff" value={lim.staff} onChange={(e) => setLim({ ...lim, staff: e.target.value })} /></Field>
        </div>
        <Button className="rounded-full" data-testid="clinic-features-save" onClick={save}>Save</Button>
      </DialogContent>
    </Dialog>
  );
}
